import { put, call, takeLatest } from 'redux-saga/effects';

import dataProvider from '../../../store/dataProvider';
import headerNotification from '../../../actionTypes/headerNotification';
import { notification } from '../../../actionTypes';

export function* acceptFollow({ payload }) {
  const { companyId, senderCompanyId, notificationId } = payload;
  try {
    yield call(dataProvider.createOne, `companies/${companyId}/sharing/${senderCompanyId}/accept/${notificationId}`);
    yield put({ type: headerNotification.acceptFollow.end, payload });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: e.message } });
  }
}

export default function* createFollowSaga() {
  yield takeLatest(headerNotification.acceptFollow.start, acceptFollow);
}
